<template>
    <v-card class="white border-boxGlobal">
        <v-card-title> Reporte de Costos Históricos de Inventario </v-card-title>
        <v-row class="mx-1">
        </v-row>
        <block v-if="loading"></block>
        <VersatileFilter :search="search" @emptyFilter="getHistoricalCostDetail"
            @filtered="filterHandler" :key="Reloadfilter" :useCache="true"
            @updateCache="updateCache" class="mx-3" :oneDateFilter="true"
            :hideSearchField="true"
            @getOneDate="setSelectedDate"
            :columnfilterEndpoint="$API.inventoryReports.getInventoryHistoricalCostFilterReportColumn">
            <InventoryHistoricalCostReportTable :data="reportsData" @exporting="onExporting" />
        </VersatileFilter>
        <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
        </alerts>
    </v-card>
</template>

<script>
import { printToExcel } from "@/helpers/printToexcel";
import VersatileFilter from "@/components/VersatileFilter";
import Block from "@/components/Block";
import Alerts from "@/components/Alerts";
import InventoryHistoricalCostReportTable from "./InventoryHistoricalCostReportTable.vue";

export default {
    name: "InventoryHistoricalCostReport",
    components: {
        Block,
        Alerts,
        VersatileFilter,
        InventoryHistoricalCostReportTable,
    },
    props: ["win", "datafilter"],
    data() {
        return {
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            loading: false,
            reportsData: [],
            search: {},
            Reloadfilter: 0,
            cacheData: [],
            selectedDate: null,
        };
    },
    methods: {
        mapCostoPromedio(response) {
            return response.map((item) => {
                item.CostoPromedio = item.CostoPromedio || 0;
                item.CostoHistorico = item.CostoHistorico || 0;
                item.FechaRegistro = item.FechaRegistro || '';
                item.TotalStock = item.TotalStock || 0;
                item.TotalCost = item.TotalCost || 0;
                return item;
            });
        },
        closeAlert() {
            this.alert.show = false;
        },
        acceptAlert() {
            this.alert.show = false;
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        setSelectedDate(date) {
            this.selectedDate = date;
            console.log('Fecha seleccionada:', date);
        },
        getHistoricalCostDetail() {
            this.loading = true;
            
            // Preparar los parámetros con la fecha seleccionada
            const params = {};
            if (this.selectedDate) {
                params.fecha = this.selectedDate;
            }
            
            this.$API.inventoryReports
                .getInventoryHistoricalCostReport(params)
                .then((response) => {
                    this.loading = false;
                    this.reportsData = this.mapCostoPromedio(response);
                    console.log('Datos recibidos:', this.reportsData);
                })
                .catch((error) => {
                    this.loading = false;
                    console.log('Error obteniendo datos históricos:', error);
                    this.showAlert('danger', 'Error', 'No se pudieron cargar los datos del reporte de costos históricos.');
                });
        },
        filterHandler(response) {
            this.reportsData = this.mapCostoPromedio(response);
        },
        updateCache(data) {
            this.cacheData = data;
        },
        onExporting(e) {
            printToExcel(e, "Reporte de Costos Históricos de Inventario");
        },
    },
    mounted() {
        this.getHistoricalCostDetail();
    },
};
</script>

<style scoped>
.btnblack {
    background-color: rgba(60, 60, 60, 1) !important;
    color: white !important;
}

.close-btn {
    color: white !important;
    position: relative !important;
    float: right !important;
}

.border {
  border-radius: 15px !important;
}
</style>
